namespace SorAraBul.Texts {

    declare namespace Db {

        namespace Administration {

            namespace Companies {
                export const AddressDetail: string;
                export const CityId: string;
                export const CityName: string;
                export const CompanyId: string;
                export const ContactNumber: string;
                export const Created: string;
                export const CreatedBy: string;
                export const Credit: string;
                export const IlceId: string;
                export const IsActive: string;
                export const LastModified: string;
                export const LastModifiedBy: string;
                export const Name: string;
                export const PostalCode: string;
                export const TaxNumber: string;
                export const TaxOffice: string;
                export const TownName: string;
            }

            namespace HasoErrorCodes {
                export const ErrorCode: string;
                export const Id: string;
                export const InsertDate: string;
                export const Message: string;
                export const UpdateDate: string;
            }

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace PurchasePackageFeatures {
                export const FeatureText: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const PurchasePackageId: string;
                export const PurchasePackageName: string;
                export const SortOrder: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace PurchasePackages {
                export const BadgeText: string;
                export const ButtonText: string;
                export const CurrencyCode: string;
                export const CurrencyId: string;
                export const CurrencyLookupName: string;
                export const CurrencySymbol: string;
                export const Features: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const IsPopular: string;
                export const Name: string;
                export const PackageCode: string;
                export const ReportCount: string;
                export const SortOrder: string;
                export const Subtitle: string;
                export const UnitPrice: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const CompanyId: string;
                export const CompanyName: string;
                export const Credit: string;
                export const DisplayName: string;
                export const Email: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const InvoiceAddress: string;
                export const IsActive: string;
                export const IsAdmin: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Roles: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace UserCreditLog {
                export const Amount: string;
                export const CompanyId: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertDisplayName: string;
                export const InsertUserId: string;
                export const NewCredit: string;
                export const OldCredit: string;
                export const PropertyId: string;
                export const PropertyPropertyName: string;
                export const TransactionType: string;
            }

            namespace UserCreditPaymentOrder {
                export const Amount: string;
                export const CompanyId: string;
                export const CompanyName: string;
                export const CreditCount: string;
                export const Id: string;
                export const InsertDate: string;
                export const PaidDate: string;
                export const PaymentCode: string;
                export const PurchasePackageId: string;
                export const PurchasePackageName: string;
                export const RawCallback: string;
                export const Status: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace Definitions {

            namespace Cities {
                export const CityCode: string;
                export const CountriesName: string;
                export const CountryId: string;
                export const Id: string;
                export const Name: string;
                export const StateId: string;
            }

            namespace Countries {
                export const CountryCode: string;
                export const GlobalName: string;
                export const Id: string;
                export const Name: string;
            }

            namespace Currencies {
                export const CurrencyCode: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LookupName: string;
                export const Name: string;
                export const Symbol: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Occupation {
                export const Code: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Pets {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Quarters {
                export const CountryId: string;
                export const DistrictId: string;
                export const DistrictName: string;
                export const Id: string;
                export const IlceCityId: string;
                export const IlceId: string;
                export const IlceName: string;
                export const Name: string;
            }

            namespace Restrictions {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const Name: string;
                export const PropertyType: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace Towns {
                export const CityCountryId: string;
                export const CityId: string;
                export const CityName: string;
                export const CountryName: string;
                export const Id: string;
                export const Name: string;
            }
        }

        namespace PropertyManagement {

            namespace Properties {
                export const Address: string;
                export const CityId: string;
                export const CityName: string;
                export const Code: string;
                export const CompanyId: string;
                export const Id: string;
                export const IlceId: string;
                export const Images: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const PropertyFullName: string;
                export const PropertyLocation: string;
                export const PropertyName: string;
                export const PropertyType: string;
                export const QuarterId: string;
                export const QuarterName: string;
                export const RequestedRentAmount: string;
                export const RequestedRentAmountWithCurrency: string;
                export const RequestedRentCurrencyId: string;
                export const RequestedRentCurrencyLookupName: string;
                export const Restrictions: string;
                export const TownName: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace PropertyRestrictions {
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const PropertyAddress: string;
                export const PropertyId: string;
                export const PropertyImages: string;
                export const PropertyPropertyName: string;
                export const PropertyPropertyType: string;
                export const PropertyRequestedRentAmount: string;
                export const RestrictionId: string;
                export const RestrictionInsertDate: string;
                export const RestrictionInsertUserId: string;
                export const RestrictionIsActive: string;
                export const RestrictionName: string;
                export const RestrictionPropertyType: string;
                export const RestrictionUpdateDate: string;
                export const RestrictionUpdateUserId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }

            namespace TenantDetail {
                export const BirthDate: string;
                export const ChildrenAges: string;
                export const ChildrenCount: string;
                export const Completed: string;
                export const EducationLevelSelf: string;
                export const EducationLevelSpouse: string;
                export const GId: string;
                export const HasChildren: string;
                export const HasPet: string;
                export const HasoBkKrediNotu: string;
                export const HasoBkKrediNotuSonuc: string;
                export const HasoCustomerId: string;
                export const HasoCustomerInfo: string;
                export const HasoKkbRefNo: string;
                export const HasoKkbXml: string;
                export const HasoMessage: string;
                export const InsertDate: string;
                export const MaritalStatus: string;
                export const MaskedTckn: string;
                export const OccupationSelf: string;
                export const OccupationSelfId: string;
                export const OccupationSelfName: string;
                export const OccupationSpouse: string;
                export const OccupationSpouseId: string;
                export const OccupationSpouseName: string;
                export const OldAddress: string;
                export const OldAddressResidenceDurationMonths: string;
                export const OldAddressResidenceDurationText: string;
                export const OldCityId: string;
                export const OldCityName: string;
                export const OldQuarterId: string;
                export const OldQuarterName: string;
                export const OldTownId: string;
                export const OldTownName: string;
                export const PetTypes: string;
                export const PropertyAddress: string;
                export const PropertyCityName: string;
                export const PropertyImages: string;
                export const PropertyName: string;
                export const PropertyQuarterName: string;
                export const PropertyRequestedRentAmount: string;
                export const PropertyRequestedRentAmountWithCurrency: string;
                export const PropertyRequestedRentCurrencyCode: string;
                export const PropertyRestrictions: string;
                export const PropertyTownName: string;
                export const PropertyType: string;
                export const SelfReportedEmail: string;
                export const SelfReportedName: string;
                export const SelfReportedPhone: string;
                export const SelfReportedSurname: string;
                export const SorsData: string;
                export const SorsDosyaId: string;
                export const SorsLocalReportUrl: string;
                export const SorsMessage: string;
                export const SorsRaporCompleteDate: string;
                export const SorsRaporJson: string;
                export const SorsRaporRequestDate: string;
                export const SorsRaporUrl: string;
                export const Step: string;
                export const Tckn: string;
                export const TenantEmail: string;
                export const TenantId: string;
                export const TenantName: string;
                export const TenantPhone: string;
                export const TenantPropertyId: string;
                export const TenantSmsVerificationCode: string;
                export const TenantStatus: string;
                export const TenantSurname: string;
                export const WorkingAdultsCount: string;
            }

            namespace TenantDetailPanel {
                export const BirthDate: string;
                export const ChildrenAges: string;
                export const ChildrenCount: string;
                export const Completed: string;
                export const EducationLevelSelf: string;
                export const EducationLevelSpouse: string;
                export const GId: string;
                export const HasChildren: string;
                export const HasPet: string;
                export const HasoBkKrediNotu: string;
                export const HasoBkKrediNotuSonuc: string;
                export const HasoCustomerId: string;
                export const HasoCustomerInfo: string;
                export const HasoKkbRefNo: string;
                export const HasoKkbXml: string;
                export const HasoMessage: string;
                export const InsertDate: string;
                export const MaritalStatus: string;
                export const MaskedTckn: string;
                export const OccupationSelf: string;
                export const OccupationSelfId: string;
                export const OccupationSelfName: string;
                export const OccupationSpouse: string;
                export const OccupationSpouseId: string;
                export const OccupationSpouseName: string;
                export const OldAddress: string;
                export const OldAddressResidenceDurationMonths: string;
                export const OldAddressResidenceDurationText: string;
                export const OldCityId: string;
                export const OldCityName: string;
                export const OldQuarterId: string;
                export const OldQuarterName: string;
                export const OldTownId: string;
                export const OldTownName: string;
                export const PetTypes: string;
                export const PetTypesString: string;
                export const PropertyAddress: string;
                export const PropertyCityName: string;
                export const PropertyImages: string;
                export const PropertyName: string;
                export const PropertyQuarterName: string;
                export const PropertyRequestedRentAmount: string;
                export const PropertyRequestedRentAmountWithCurrency: string;
                export const PropertyRequestedRentCurrencyCode: string;
                export const PropertyRestrictions: string;
                export const PropertyTownName: string;
                export const PropertyType: string;
                export const SelfReportedEmail: string;
                export const SelfReportedName: string;
                export const SelfReportedPhone: string;
                export const SelfReportedSurname: string;
                export const SorsData: string;
                export const SorsDosyaId: string;
                export const SorsLocalReportUrl: string;
                export const SorsMessage: string;
                export const SorsRaporCompleteDate: string;
                export const SorsRaporJson: string;
                export const SorsRaporRequestDate: string;
                export const SorsRaporUrl: string;
                export const Step: string;
                export const Tckn: string;
                export const TenantCompanyId: string;
                export const TenantEmail: string;
                export const TenantId: string;
                export const TenantInsertUserId: string;
                export const TenantName: string;
                export const TenantPhone: string;
                export const TenantPropertyId: string;
                export const TenantSmsVerificationCode: string;
                export const TenantStatus: string;
                export const TenantSurname: string;
                export const WorkingAdultsCount: string;
            }

            namespace TenantPets {
                export const Id: string;
                export const PetId: string;
                export const TenantDetailId: string;
            }

            namespace Tenants {
                export const CompanyId: string;
                export const Email: string;
                export const Id: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const LastActionDate: string;
                export const Link: string;
                export const Name: string;
                export const NameSurname: string;
                export const Phone: string;
                export const PhoneNumeric: string;
                export const PropertyAddress: string;
                export const PropertyFullName: string;
                export const PropertyId: string;
                export const PropertyImages: string;
                export const PropertyPropertyName: string;
                export const PropertyPropertyType: string;
                export const PropertyRequestedRentAmount: string;
                export const Rating: string;
                export const ReportUrl: string;
                export const SmsVerificationCode: string;
                export const SorsLocalReportUrl: string;
                export const Status: string;
                export const Surname: string;
                export const TenantDetailGId: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ProfileUpdate {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    SorAraBul['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{Companies:{AddressDetail:1,CityId:1,CityName:1,CompanyId:1,ContactNumber:1,Created:1,CreatedBy:1,Credit:1,IlceId:1,IsActive:1,LastModified:1,LastModifiedBy:1,Name:1,PostalCode:1,TaxNumber:1,TaxOffice:1,TownName:1},HasoErrorCodes:{ErrorCode:1,Id:1,InsertDate:1,Message:1,UpdateDate:1},Language:{Id:1,LanguageId:1,LanguageName:1},PurchasePackageFeatures:{FeatureText:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,PurchasePackageId:1,PurchasePackageName:1,SortOrder:1,UpdateDate:1,UpdateUserId:1},PurchasePackages:{BadgeText:1,ButtonText:1,CurrencyCode:1,CurrencyId:1,CurrencyLookupName:1,CurrencySymbol:1,Features:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,IsPopular:1,Name:1,PackageCode:1,ReportCount:1,SortOrder:1,Subtitle:1,UnitPrice:1,UpdateDate:1,UpdateUserId:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{CompanyId:1,CompanyName:1,Credit:1,DisplayName:1,Email:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,InvoiceAddress:1,IsActive:1,IsAdmin:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Roles:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1},UserCreditLog:{Amount:1,CompanyId:1,Id:1,InsertDate:1,InsertDisplayName:1,InsertUserId:1,NewCredit:1,OldCredit:1,PropertyId:1,PropertyPropertyName:1,TransactionType:1},UserCreditPaymentOrder:{Amount:1,CompanyId:1,CompanyName:1,CreditCount:1,Id:1,InsertDate:1,PaidDate:1,PaymentCode:1,PurchasePackageId:1,PurchasePackageName:1,RawCallback:1,Status:1,UserDisplayName:1,UserEmail:1,UserId:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},Definitions:{Cities:{CityCode:1,CountriesName:1,CountryId:1,Id:1,Name:1,StateId:1},Countries:{CountryCode:1,GlobalName:1,Id:1,Name:1},Currencies:{CurrencyCode:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,LookupName:1,Name:1,Symbol:1,UpdateDate:1,UpdateUserId:1},Occupation:{Code:1,Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,UpdateDate:1,UpdateUserId:1},Pets:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,UpdateDate:1,UpdateUserId:1},Quarters:{CountryId:1,DistrictId:1,DistrictName:1,Id:1,IlceCityId:1,IlceId:1,IlceName:1,Name:1},Restrictions:{Id:1,InsertDate:1,InsertUserId:1,IsActive:1,Name:1,PropertyType:1,UpdateDate:1,UpdateUserId:1},Towns:{CityCountryId:1,CityId:1,CityName:1,CountryName:1,Id:1,Name:1}},PropertyManagement:{Properties:{Address:1,CityId:1,CityName:1,Code:1,CompanyId:1,Id:1,IlceId:1,Images:1,InsertDate:1,InsertUserId:1,PropertyFullName:1,PropertyLocation:1,PropertyName:1,PropertyType:1,QuarterId:1,QuarterName:1,RequestedRentAmount:1,RequestedRentAmountWithCurrency:1,RequestedRentCurrencyId:1,RequestedRentCurrencyLookupName:1,Restrictions:1,TownName:1,UpdateDate:1,UpdateUserId:1},PropertyRestrictions:{Id:1,InsertDate:1,InsertUserId:1,PropertyAddress:1,PropertyId:1,PropertyImages:1,PropertyPropertyName:1,PropertyPropertyType:1,PropertyRequestedRentAmount:1,RestrictionId:1,RestrictionInsertDate:1,RestrictionInsertUserId:1,RestrictionIsActive:1,RestrictionName:1,RestrictionPropertyType:1,RestrictionUpdateDate:1,RestrictionUpdateUserId:1,UpdateDate:1,UpdateUserId:1},TenantDetail:{BirthDate:1,ChildrenAges:1,ChildrenCount:1,Completed:1,EducationLevelSelf:1,EducationLevelSpouse:1,GId:1,HasChildren:1,HasPet:1,HasoBkKrediNotu:1,HasoBkKrediNotuSonuc:1,HasoCustomerId:1,HasoCustomerInfo:1,HasoKkbRefNo:1,HasoKkbXml:1,HasoMessage:1,InsertDate:1,MaritalStatus:1,MaskedTckn:1,OccupationSelf:1,OccupationSelfId:1,OccupationSelfName:1,OccupationSpouse:1,OccupationSpouseId:1,OccupationSpouseName:1,OldAddress:1,OldAddressResidenceDurationMonths:1,OldAddressResidenceDurationText:1,OldCityId:1,OldCityName:1,OldQuarterId:1,OldQuarterName:1,OldTownId:1,OldTownName:1,PetTypes:1,PropertyAddress:1,PropertyCityName:1,PropertyImages:1,PropertyName:1,PropertyQuarterName:1,PropertyRequestedRentAmount:1,PropertyRequestedRentAmountWithCurrency:1,PropertyRequestedRentCurrencyCode:1,PropertyRestrictions:1,PropertyTownName:1,PropertyType:1,SelfReportedEmail:1,SelfReportedName:1,SelfReportedPhone:1,SelfReportedSurname:1,SorsData:1,SorsDosyaId:1,SorsLocalReportUrl:1,SorsMessage:1,SorsRaporCompleteDate:1,SorsRaporJson:1,SorsRaporRequestDate:1,SorsRaporUrl:1,Step:1,Tckn:1,TenantEmail:1,TenantId:1,TenantName:1,TenantPhone:1,TenantPropertyId:1,TenantSmsVerificationCode:1,TenantStatus:1,TenantSurname:1,WorkingAdultsCount:1},TenantDetailPanel:{BirthDate:1,ChildrenAges:1,ChildrenCount:1,Completed:1,EducationLevelSelf:1,EducationLevelSpouse:1,GId:1,HasChildren:1,HasPet:1,HasoBkKrediNotu:1,HasoBkKrediNotuSonuc:1,HasoCustomerId:1,HasoCustomerInfo:1,HasoKkbRefNo:1,HasoKkbXml:1,HasoMessage:1,InsertDate:1,MaritalStatus:1,MaskedTckn:1,OccupationSelf:1,OccupationSelfId:1,OccupationSelfName:1,OccupationSpouse:1,OccupationSpouseId:1,OccupationSpouseName:1,OldAddress:1,OldAddressResidenceDurationMonths:1,OldAddressResidenceDurationText:1,OldCityId:1,OldCityName:1,OldQuarterId:1,OldQuarterName:1,OldTownId:1,OldTownName:1,PetTypes:1,PetTypesString:1,PropertyAddress:1,PropertyCityName:1,PropertyImages:1,PropertyName:1,PropertyQuarterName:1,PropertyRequestedRentAmount:1,PropertyRequestedRentAmountWithCurrency:1,PropertyRequestedRentCurrencyCode:1,PropertyRestrictions:1,PropertyTownName:1,PropertyType:1,SelfReportedEmail:1,SelfReportedName:1,SelfReportedPhone:1,SelfReportedSurname:1,SorsData:1,SorsDosyaId:1,SorsLocalReportUrl:1,SorsMessage:1,SorsRaporCompleteDate:1,SorsRaporJson:1,SorsRaporRequestDate:1,SorsRaporUrl:1,Step:1,Tckn:1,TenantCompanyId:1,TenantEmail:1,TenantId:1,TenantInsertUserId:1,TenantName:1,TenantPhone:1,TenantPropertyId:1,TenantSmsVerificationCode:1,TenantStatus:1,TenantSurname:1,WorkingAdultsCount:1},TenantPets:{Id:1,PetId:1,TenantDetailId:1},Tenants:{CompanyId:1,Email:1,Id:1,InsertDate:1,InsertUserId:1,LastActionDate:1,Link:1,Name:1,NameSurname:1,Phone:1,PhoneNumeric:1,PropertyAddress:1,PropertyFullName:1,PropertyId:1,PropertyImages:1,PropertyPropertyName:1,PropertyPropertyType:1,PropertyRequestedRentAmount:1,Rating:1,ReportUrl:1,SmsVerificationCode:1,SorsLocalReportUrl:1,Status:1,Surname:1,TenantDetailGId:1,UpdateDate:1,UpdateUserId:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ProfileUpdate:{FormTitle:1,SubmitButton:1,Success:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}});
}
